import { useNavigate } from 'react-router';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

import { Button } from '../../../components';

const customIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

interface ITSectionProps {
  title: string;
  description: string;
  overview: string | number;
  placeholderText?: string;
  reviewLink: string | ((locationId: string) => string);
  isEnabled?: boolean;
  loading?: boolean;
  onAction?: () => void;
  locationId?: string;
}

const ITSection = ({
  title,
  description,
  overview,
  placeholderText,
  reviewLink,
  isEnabled,
  loading,
  onAction,
  locationId,
}: ITSectionProps) => {
  const navigate = useNavigate();

  const enabledActions = (
    <div className="flex flex-col items-center justify-end gap-2">
        <Button
          onClick={() =>
            navigate(
              typeof reviewLink === 'function'
                ? reviewLink(locationId ?? '')
                : reviewLink,
            )
          }
          type="secondary"
          className="min-w-[163px] "
        >
          Review
        </Button>
        {onAction && (
          <button
            onClick={onAction}
            className="text-xsm underline text-[#979797] font-normal"
          >
            not applicable
          </button>
        )}
      </div>
  )

  const disabledActions = (
    <Button
      onClick={onAction}
      type="secondary"
      className="min-w-[163px] mb-[23.9px]"
    >
      Enable {title}
    </Button>
  )

  const actions = isEnabled ? enabledActions : disabledActions;
  
  return (
    <div className={ `flex flex-col items-center gap-1 text-center border border-tertiary-200 rounded-[10px] p-5 ${isEnabled ? '' : 'bg-[#0000000D]'}` }>
      <div className={ `space-y-1.5 ${isEnabled ? 'opacity-100' : 'opacity-40'}` }>
        <div className="text-base font-bold">{title}</div>
        <div className="max-w-110">{description}</div>
      </div>
      <div className={ `flex items-end basis-full ${isEnabled ? 'opacity-100' : 'opacity-40'}` }>
        {
          loading ? 
          <Spin indicator={customIcon} /> :
          <div className='flex flex-col gap-0.5 !text-3xl font-bold text-blue'>
            {overview}
            <span className="placeholder-text !text-[14px]">
              { placeholderText ? placeholderText : 'unique applications tagged' }
            </span>
          </div>
        }
      </div>
      {actions}
    </div>
  );
};

export default ITSection;
